import { IProduct } from "app/Sales/point-of-sale/domain/IProduct";
import { Supplier } from "./supplier";

export class PurchaseOrder {
   _id: string;
   purchaseOrderNumber: string;
   purchaseOrderDate: Date;
   remarks: string;
   products: IProduct[];
   createdBy: string;
   updatedBy: string;
   paid: number;
   paymentMode: string;
   company: string;
   branch: string;
   supplier: Supplier;
   subTotal: number;
   status: string;
   remainingSubtotal: number;
   returned: number;
   total: number;
}